import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import HatmPage from './pages/HatmPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import JuzSubmitPage from './pages/JuzSubmitPage';
import NoPage from './pages/NoPage';
import CreateHatmPage from './pages/CreateHatmPage';
import Header from './components/Header';
import { createTheme, ThemeProvider } from '@mui/material';
import ContactUsPage from './pages/ContactUsPage';
import TanitimPage from './pages/TanitimPage';
import Footer from './components/Footer';
import ReadListPage from './pages/ReadListPage';
import google5fea4d485c4dc88b from './google5fea4d485c4dc88b';
import MaxWidthWrapper from './components/MaxWidthWrapper';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#B0C4B1',
    },
    secondary: {
      main: '#EDAFB8',
    },
  },
  typography: {
    fontFamily: [
      'Poppins',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiTextField: {
      defaultProps: {
        sx: {
          borderRadius: "10px",
          backgroundColor: "white"
        }
      }
    }
  },
  custom: {
    maxWidth: '800px'
  }
});

function App() {

  return (
    <ThemeProvider theme={theme}><div className="App">

      <header>
      <Header/>
      </header>
      
      <MaxWidthWrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hatimler/:id" element={<HatmPage />} />
          <Route path="hatimolustur" element={<CreateHatmPage />} />
          <Route path="giris" element={<LoginPage />} />
          <Route path="kayit" element={<RegisterPage />} />
          <Route path="cuzsec" element={<JuzSubmitPage />} />
          <Route path="iletisim" element={<ContactUsPage/>} />
          <Route path="tanitim" element={<TanitimPage/>} />
          <Route path="okumalistem" element={<ReadListPage/>} />
          <Route path="google5fea4d485c4dc88b.html" element={<google5fea4d485c4dc88b/>} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
      </MaxWidthWrapper>

      <footer>
        <Footer/>
      </footer>
      
    </div>
    </ThemeProvider>
  );
}

export default App;
